module.exports = __webpack_public_path__ + "static/media/lvjian-xiangshengqiche.06f7965c.png";